var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yearProcent"},[_c('span',{class:{'active': _vm.values},on:{"click":function($event){_vm.values = true}}},[_vm._v("Отображать в % годовых")]),_c('span',{class:{'active': !_vm.values},on:{"click":function($event){_vm.values = false}}},[_vm._v("Отображать в % от суммы гарантии")])])
}
var staticRenderFns = []

export { render, staticRenderFns }